"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _commonSetLocation = require("@mmc/common-set-location");
var _footerTop = _interopRequireDefault(require("../styles/footer-top.css"));
var _socialLink = _interopRequireDefault(require("./social-link"));
var _footerAccordion = _interopRequireDefault(require("./footer-accordion"));
var FooterTop = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(FooterTop, _React$Component);
  function FooterTop(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.renderAccordion = _this.renderAccordion.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderSocialLinks = _this.renderSocialLinks.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = FooterTop.prototype;
  _proto.renderAccordion = function renderAccordion(categories, theme, screenWidth) {
    var mobileBreakPoint = 767;
    var forcedOpen = screenWidth > mobileBreakPoint;
    var market = this.props.market;
    return categories.map(function (_ref, i) {
      var heading = _ref.heading,
        links = _ref.links;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: i,
        className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-4'], _footerTop["default"].accordionBox)
      }, /*#__PURE__*/_react["default"].createElement(_footerAccordion["default"], {
        theme: theme,
        heading: heading,
        forcedOpen: forcedOpen,
        links: links,
        iterator: i,
        market: market
      }));
    }).sort(function (a, b) {
      return a.order - b.order;
    });
  };
  _proto.renderSocialLinks = function renderSocialLinks(sociallinks) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _footerTop["default"].socialLinkContainer
    }, sociallinks.map(function (oneSocialLink, i) {
      return /*#__PURE__*/_react["default"].createElement(_socialLink["default"], {
        key: i,
        oneSocialLink: oneSocialLink
      });
    }));
  };
  _proto.render = function render() {
    var _this$props = this.props,
      locationSelector = _this$props.locationSelector,
      theme = _this$props.theme,
      screenWidth = _this$props.screenWidth,
      sociallinks = _this$props.sociallinks,
      categories = _this$props.categories;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme.row, _footerTop["default"].container)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-sm-offset-1'], theme['col-sm-6'], _footerTop["default"].accordionWrapper)
    }, this.renderAccordion(categories, theme, screenWidth)), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-4'], _footerTop["default"].rightContainer)
    }, locationSelector && /*#__PURE__*/_react["default"].createElement(_commonSetLocation.CommonSetLocationForm, {
      className: _footerTop["default"].commonSetLocation,
      data: locationSelector,
      dark: true,
      padding: false,
      theme: theme
    }), sociallinks[0] && this.renderSocialLinks(sociallinks, theme)));
  };
  return FooterTop;
}(_react["default"].Component);
exports["default"] = FooterTop;
FooterTop.displayName = 'FooterTop';